export const encodeFiltersToQueryParam = (filters) => {
  try {
    const activeFiltersData = filters
      .filter(f => f.isActive && f.value !== null)
      .map(({ key, value, operator, isActive, activeSince }) => ({
        key,
        value,
        operator,
        isActive,
        activeSince
      }));

    if (activeFiltersData.length === 0) {
      return null;
    }

    const jsonString = JSON.stringify(activeFiltersData);
    return btoa(encodeURIComponent(jsonString));
  } catch (error) {
    console.error("Failed to encode filters to query param:", error);
    return null;
  }
};

export const decodeFiltersFromQueryParam = (encodedString) => {
  try {
    if (!encodedString) return null;

    const jsonString = decodeURIComponent(atob(encodedString));
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Failed to decode filters from query param:", error);
    return null;
  }
};

export const buildFilterQueryParams = (filters, paramName = "filters") => {
  const encoded = encodeFiltersToQueryParam(filters);
  if (!encoded) return {};

  return { [paramName]: encoded };
};

export const mergeWithCurrentParams = (searchParams, newParams) => {
  const merged = new URLSearchParams(searchParams);

  Object.entries(newParams).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      merged.delete(key);
    } else {
      merged.set(key, value);
    }
  });

  return merged;
};

